// extracted by mini-css-extract-plugin
module.exports = {"root":"Badge__root___1HjQH","small":"Badge__small___1ViL8","gray":"Badge__gray___uLiP_"};